/**
 * Summarizes the path for display purposes. If the path is empty or
 * the root path, it displays "this project".
 */
export function summarizePath(path: string): string {
  if (!path || path === '/') {
    return 'this project';
  }

  return path;
}
